import React from 'react'
import EmptyLink from '@aytm/app/swidget/base/components/EmptyLink.tsx'
import useViewport from '@aytm/app/swidget/base/modules/viewport/useViewport.ts'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import { IEcommerceQuestionSchema } from '@aytm/app/swidget/base/questions/Ecommerce/types.ts'
import style from './Header.module.scss'

export interface IHeaderProps {
  totals: number[]
  schema: IEcommerceQuestionSchema
  findability: boolean
  showCart: boolean
  onCartOpen: () => void
  clearSelection: () => void
  onHomeClick: () => void
}

const Header = ({ totals, schema, findability, showCart, onCartOpen, clearSelection, onHomeClick }: IHeaderProps) => {
  const viewport = useViewport()
  const { t } = useSurveyLocale()
  return (
    <>
      {viewport.mobile ? (
        <>
          {!showCart && (
            <div className={style.headerMobile}>
              <button className={style.back} onClick={onHomeClick}>
                <i className="pi pi-arrow-left" />
              </button>
              <div className={style.input}>
                <EmptyLink color="#CC0000">
                  <div className={style.search} />
                </EmptyLink>
                <div
                  className={style.condition}
                  dangerouslySetInnerHTML={{ __html: schema.search_condition || '' }}
                  onClick={clearSelection}
                />
              </div>
              <EmptyLink color="#CC0000">
                <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <rect x="4" y="4" width="10" height="10" stroke="#cc0000" strokeWidth="1" fill="none" />
                  <rect x="8" y="8" width="10" height="10" stroke="#cc0000" strokeWidth="1" fill="none" />
                  <line x1="8" y1="12" x2="12" y2="8" stroke="#cc0000" strokeWidth="1" />
                  <line x1="10" y1="14" x2="14" y2="10" stroke="#cc0000" strokeWidth="1" />
                </svg>
              </EmptyLink>
            </div>
          )}
        </>
      ) : (
        <header className={style.header}>
          <div className={style.top}>
            <div className={style.leftColumn}>
              <EmptyLink color="#CC0000">
                <div className={style.lcButton}>
                  <div className={style.iconTrack} />
                  <div>{t('questions', 'ec', 'target', 'shipTo')}</div>
                </div>
              </EmptyLink>
              <EmptyLink color="#CC0000">
                <div className={style.lcButton}>
                  <div className={style.iconStore} />
                  <div>{t('questions', 'ec', 'target', 'cedar')}</div>
                </div>
              </EmptyLink>
            </div>
            <div className={style.rightColumn}>
              <EmptyLink color="#CC0000">
                <div className={style.rcButton}>{t('questions', 'ec', 'target', 'circle')}</div>
              </EmptyLink>
              <EmptyLink color="#CC0000">
                <div className={style.rcButton}>{t('questions', 'ec', 'target', 'circleCard')}</div>
              </EmptyLink>
              <EmptyLink color="#CC0000">
                <div className={style.rcButton}>{t('questions', 'ec', 'target', 'circle360')}</div>
              </EmptyLink>
              <EmptyLink color="#CC0000">
                <div className={style.rcButton}>{t('questions', 'ec', 'target', 'registryWish')}</div>
              </EmptyLink>
              <EmptyLink color="#CC0000">
                <div className={style.rcButton}>{t('questions', 'ec', 'target', 'weeklyAd')}</div>
              </EmptyLink>
              <EmptyLink color="#CC0000">
                <div className={style.rcButton}>{t('questions', 'ec', 'target', 'find')}</div>
              </EmptyLink>
            </div>
          </div>
          <div className={style.bottom}>
            <div className={style.inner}>
              <button className={style.logo} onClick={onHomeClick} />
              <EmptyLink color="#CC0000">
                <div className={style.text}>
                  {t('questions', 'ec', 'target', 'categories')}
                  <i className="pi pi-angle-down" />
                </div>
              </EmptyLink>
              <EmptyLink color="#CC0000">
                <div className={style.text}>
                  {t('questions', 'ec', 'target', 'deals')}
                  <i className="pi pi-angle-down" />
                </div>
              </EmptyLink>
              <EmptyLink color="#CC0000">
                <div className={style.text}>
                  {t('questions', 'ec', 'target', 'feat')}
                  <i className="pi pi-angle-down" />
                </div>
              </EmptyLink>
              <EmptyLink color="#CC0000">
                <div className={style.text}>
                  {t('questions', 'ec', 'target', 'pickupDelivery')}
                  <i className="pi pi-angle-down" />
                </div>
              </EmptyLink>
              <div className={style.input}>
                <div
                  className={style.condition}
                  dangerouslySetInnerHTML={{ __html: schema.search_condition || '' }}
                  onClick={clearSelection}
                />
                <EmptyLink color="#CC0000">
                  <div className={style.micro} />
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.cross} />
                </EmptyLink>
                <EmptyLink color="#CC0000">
                  <div className={style.search} />
                </EmptyLink>
              </div>
              <EmptyLink color="#CC0000">
                <div className={style.sign}>
                  <div className={style.account} />
                  <div className={style.signIn}>{t('questions', 'ec', 'target', 'sign')}</div>
                  <i className="pi pi-angle-down" />
                </div>
              </EmptyLink>
              {findability ? (
                <EmptyLink color="#CC0000">
                  <div className={style.cartIcon} />
                </EmptyLink>
              ) : (
                <button className={style.cart} onClick={onCartOpen}>
                  {totals[0] > 0 && <div className={style.amount}>{totals[0] > 100 ? '99+' : totals[0]}</div>}
                  <div className={style.cartIcon} />
                </button>
              )}
            </div>
          </div>
        </header>
      )}
    </>
  )
}
export default Header
